<template>
  <el-dialog title="子账号" :visible.sync="formVisible" :close-on-click-modal="false" width="1000px">
    <div class="flexs justify-end">
      <el-button type="primary" size="mini" @click="handleOperate(1)">批量使用</el-button>
    <el-button type="info" size="mini" @click="handleOperate(0)">批量停用</el-button>
    </div>

    <el-table v-loading="listLoading" :data="list" height="300" class="mt20" @selection-change="selectionChange">
      <el-table-column type="selection" width="50" />
      <el-table-column label="子账号个人信息" prop="" align="center" fixed width="160">
        <template slot-scope="{row}">
          <div @click="handleShowDetail(row.customer.id)">
            <el-link type="primary">{{row.customer.name}}({{row.customerLevel.name}})</el-link><br />
            <el-link type="primary">{{row.customer.pho}}</el-link>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="使用模块" prop="" align="center" width="110" fixed>
        <template slot-scope="{row}">
          {{ setType(row.customer.useModel)}}
        </template>
      </el-table-column>
      <el-table-column label="子账号核算方式" prop="" align="center" width="140">
        <template slot-scope="{row}" >
        <!-- <template slot-scope="{row}" > -->
          <!-- {{row.customer.mainId?'子账号':'主账号'}} -->
          {{row.customer.isUseParentWallet===1?'与主账号一起核算':(row.customer.isUseParentWallet===0?'独立核算':'-')}}
        </template>
      </el-table-column>
      <el-table-column label="企业认证信息" prop="" align="" width="160">
        <template slot-scope="{row}">
          <div @click="handleShowDetail(row.customer.id)" v-if="row.customerCertificates">
            <el-link type="primary" >认证类型：{{row.customerCertificates.certificatesType==1?'企业认证':'个人认证'}}</el-link><br />
            <el-link type="primary" v-if="row.customerCertificates.certificatesType==1">企业名称：{{row.customerCertificates?row.customerCertificates.companyName:''}}</el-link>
            <el-link type="primary" v-if="row.customerCertificates.certificatesType==2">姓名：{{row.customerCertificates?row.customerCertificates.companyName:''}}</el-link>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="申请账号时间" prop="customer.createdTime" align="center" sortable width="160">
        <template slot-scope="{row}">
          {{dayjs(row.customer.createdTime).format("YYYY-MM-DD HH:mm:ss")}}
        </template>
      </el-table-column>
      <el-table-column label="状态" prop="" align="center" width="110">
        <template slot-scope="{row}">
          {{row.customer.state==1?'使用中':row.customer.state==0?'已停用':''}}
        </template>
      </el-table-column>
      <el-table-column label="操作" align="center" fixed="right" width="70">
        <template slot-scope="{row}">
          <el-button type="text" @click="handleUpdate(row)">编辑</el-button>
        </template>
      </el-table-column>
    </el-table>
     <pagination v-show="total>0" :total="total" :pageNo.sync="query.pageNo" :pageSize.sync="query.pageSize" @pagination="doQueryList" />
    <div slot="footer" class="dialog-footer">
      <el-button type="primary" @click="doCreate()">
        关闭
      </el-button>
    </div>
  </el-dialog>
</template>

<script>
  import clientListApi from '@/api/client/clientList'
  export default {
    data() {
      return {
        formVisible: false,
        listLoading: true,
        list: [],
        query: {
          pageNo: 1,
          pageSize: 10,
          customerType:3,
          isOpenSea:0
        },
        id:null,
        total: 0,
        selectItems:[]
      }
    },
    created() {

    },
    methods: {
      setType(str){
        if(str){
          let arr=str.split('#').filter(i=>i)
          return arr.map(i=>{
            if(i==1){
              i= '学习模块'
            }else{
              i= '订货模块'
            }
            return i
          }).join(',')
          // console.log('arr: ',arr);
          // return
        }
      },
      handleShow(row) {
        console.log('row: ', row);
        this.id=row.customer.id
        // this.info = row
        this.formVisible = true
        this.doQueryList({ pageNo: 1 })
        this.$nextTick(() => {

        })
      },
      /**
       * 选择框变化
       */
      selectionChange(val) {
        this.selectItems = val
      },
      //查看信息
      handleShowDetail(id){
        this.formVisible = false;
        this.$emit('handleShow', id)
      },
      // 编辑
      handleUpdate(row){
        this.formVisible = false;
        this.$emit('handleUpdate', row)
      },
      // 批量处理
      async handleOperate(type){
        if (this.selectItems.length <= 0) {
          this.$common.showMsg('warning', '请选择客户')
          return
        }
        let arr=[]
        arr=this.selectItems.map(item=>({id:item.customer.id,isOpenSea:0,state:type}))
        await clientListApi.updateAccount(arr)
        this.$message.success('提交成功！您的任务已开始执行，请耐心等待。您可以前往任务表查看进度')
        this.doQueryList({ pageNo: 1 })
      },
      /**
       * 执行列表查询
       */
      doQueryList({ pageNo, pageSize }) {
        if (pageNo) {
          this.query.pageNo = pageNo
        }
        if (pageSize) {
          this.query.pageSize = pageSize
        }
        // console.log('this.query: ',this.query,this.dateTime);
        // return
        let query={...this.query,mainId:this.id}

        // return
        // this.query.displayPosition=this.activeName
        this.listLoading = true
        return clientListApi.fetchList(query)
          .then(({data}) => {
            console.log("data: ",data);
            this.list = data.list
            this.total = data.total
          })
          .finally(() => {
            this.listLoading = false
          })
      },
      doCreate() {
        this.formVisible = false;
        this.$emit('created')
      },
    }
  }
</script>
<style lang="scss" scoped>
  // .label {
  //   display: flex;
  //   margin-bottom: 26px;

  //   &>div {
  //     height: 40px;
  //     margin-right: 18px;
  //     // line-height: 40px;
  //   }

  //   .label-box {
  //     padding: 12px 24px;
  //     border-radius: 4px;
  //     border: 1px solid #D9D9D9
  //   }

  //   .label-active {
  //     border: 1px solid #60B7DC;
  //     background: #5DBDE733;
  //   }
  // }

  // ::v-deep .el-upload--picture-card {
  //   width: 54px;
  //   height: 54px;
  //   line-height: 62px;
  // }

  // ::v-deep .el-upload-list__item {
  //   width: 54px;
  //   height: 54px;
  // }

  // ::v-deep .el-select {
  //   width: 100%;
  // }

  // ::v-deep .el-cascader {
  //   width: 100%;
  // }

  // ::v-deep .el-dialog {
  //   max-height: 88vh;
  //   margin-top: 6vh !important;
  // }

  // ::v-deep .el-form {
  //   max-height: 64vh !important;
  //   overflow-y: auto;
  // }

  // .el-form-item--small.el-form-item {
  //   width: 48%;
  //   display: inline-block;
  //   vertical-align: top;
  // }

  // .el-date-editor--datetimerange.el-input,
  // .el-date-editor--datetimerange.el-input__inner {
  //   width: 100%;
  // }

  // .el-form-item--small.el-form-item.width100 {
  //   width: 97%;
  // }

  // ::v-deep .avatar-uploader .el-upload {
  //   border: 1px dashed #d9d9d9;
  //   border-radius: 6px;
  //   cursor: pointer;
  //   position: relative;
  //   overflow: hidden;
  // }

  // .avatar-uploader .el-upload:hover {
  //   border-color: #409EFF;
  // }

  // .avatar-uploader-icon {
  //   font-size: 28px;
  //   color: #8c939d;
  //   width: 54px;
  //   height: 54px;
  //   line-height: 54px;
  //   text-align: center;
  // }

  // .avatar {
  //   width: 54px;
  //   height: 54px;
  //   display: block;
  // }

  // .card-uploader img {
  //   height: 132px;
  //   width: 194px;
  //   margin-right: 56px;
  // }
</style>
